module.exports = __webpack_public_path__ + "assets/selectLabel.fc17a3750269af46dbfaaea1122a282c.png";